// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3wSL2","rootSmall":"AddTileButton_rootSmall__jR-RA"};